export const fields = {
  expiryDate: {
    label: "Expiry Date",
    rules: "required|validDate",
    value: "",
  },
};
